var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWord = function SvgWord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A5699",
    d: "M18.814 0h2.446v3.256c4.376.024 8.748-.045 13.12.024.933-.094 1.665.627 1.58 1.555.068 8.017-.017 16.039.04 24.056-.04.822.082 1.734-.397 2.462-.597.423-1.37.37-2.065.403-4.094-.02-8.184-.012-12.278-.012V35h-2.556C12.48 33.869 6.24 32.831.002 31.744c-.004-9.494 0-18.99 0-28.48C6.27 2.174 12.545 1.111 18.815 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21 5h14v26H21v-3.25h11.03v-1.625H21v-2.031h11.03v-1.625H21v-2.032h11.03v-1.625H21v-2.03h11.03v-1.626H21v-2.031h11.03V11.5H21V9.469h11.03V7.844H21V5zM8.09 12.476c.775-.044 1.549-.077 2.323-.118.542 2.749 1.096 5.493 1.683 8.23.46-2.827.97-5.644 1.463-8.466.815-.028 1.63-.073 2.441-.122-.921 3.945-1.728 7.924-2.735 11.845-.68.354-1.7-.017-2.506.04-.542-2.695-1.174-5.374-1.659-8.082-.476 2.63-1.096 5.236-1.642 7.85-.782-.04-1.569-.089-2.356-.142-.676-3.583-1.47-7.142-2.102-10.733.697-.033 1.398-.061 2.095-.086.42 2.594.896 5.176 1.263 7.773.575-2.663 1.162-5.326 1.732-7.989z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/word.f9580e6f.svg";
export { ForwardRef as ReactComponent };